import React from "react";
import "./Features.css";
import { Container } from "react-bootstrap";
import { Feature } from "../../../../Components";
import image1 from "../../../../assets/Images/about/target.svg";


const Features = ({ url, section }) => {
  const services = section?.data?.services;

  if (services)
    return (
      <div className="about-features-div">
        <Container>
          <div className="about-feauture-container">
            {services.objects.slice(0, 4).map((service, index) => ( // Limit to 4 items
              <Feature
                key={index} // Add a unique key
                image={service.icon ? url + "/" + service.icon : image1}
                title={service.name}
                description={service.description}
              />
            ))}
          </div>
        </Container>
      </div>
    );
  else {
    return <></>;
  }
};

export default Features;
